import React, { useState, useEffect } from 'react';
import { Box, Grid, GridItem, Flex } from '@chakra-ui/react';
import JobCard from './jobCard';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAssignedJobs } from '../../store/slices/assignedJobSlice';
import { useJobListRefreshContext } from '../../utils/context/JobListRefresh';

const JobApprovedList = () => {
  const { jobListRefresh } = useJobListRefreshContext();
  const [selectedJob, setSelectedJob] = useState(null);
  const [jobs, setJobs] = useState([]);
  const dispatch = useDispatch();
  const assignedJobs = useSelector((state) => state.assignedJobs.assignedJobs);
  const loading = useSelector((state) => state.assignedJobs.loading);
  const error = useSelector((state) => state.assignedJobs.error);
  useEffect(() => {
    // Dispatch the fetchAssignedJobs thunk to load assigned jobs
    dispatch(fetchAssignedJobs());
  }, [dispatch, jobListRefresh]);
  useEffect(() => {
    setJobs(assignedJobs); // Sync jobs with Redux state
  }, [assignedJobs]);

 // Conditional rendering for loading and error states
 if (loading) {
  return <p>Loading assigned jobs...</p>;
}

if (error) {
  return <p>Error fetching jobs: {error}</p>;
}
  const handleJobClick = (job) => {
    setSelectedJob(job);
  };

  const handleClose = () => {
    setSelectedJob(null);
  };

  return (
    <Box p={4} overflowX="auto" overflowY="hidden" whiteSpace="nowrap" h="100%" w="100%">
      {/* <Grid
        templateColumns="repeat(auto-fill, minmax(250px, 1fr))"
        gap={6}
        display="flex"
        flexDirection="row"
      >
        {jobs.map((job, index) => (
          <GridItem key={index} mx={2}>
            <JobApprovedCard 
              {...job} 
              onClick={() => handleJobClick(job)} 
              isApplied={job.isApplied} // Ensure isApplied is passed
              isSaved={job.isSaved} // Pass isSaved to JobCard
              category="All" // Assuming "All" category for this example
            />
          </GridItem>
        ))}
      </Grid> */}
            <Flex gap={4} alignItems="flex-start">
        {assignedJobs.map((job, index) => (
          <Box key={index} flex="0 0 auto" width="300px"       height={job.isAssigned && job.isFromApprovedList ? "130px" : "160px"}>
            <JobCard 
              {...job} 
              onClick={() => handleJobClick(job)} 
              isAssigned={job.isAssigned}
              category="All"
              isFromApprovedList={true}
            />
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default JobApprovedList;